<template>
  <div
    class="brochure"
    :style="{
      'padding': !isSimulation && isDesktop ? '15px 30px 15px 30px' : '15px'
    }"
  >
    <v-card
      class="mx-auto"
      style="border-radius: 10px !important;padding-bottom: 15px !important;"
      :style="{ 'background-color': `${BGColorContent} !important`,
                'font-size': `${FontSizeContent}px !important`,
                'font-family': `${FontContent} !important`,
              }"
    >
      <v-img
        v-if="data.BrochureImage"
        :src="data.BrochureImage"
        height="130px"
        :style="{ 
            'max-width': isSimulation ? '345px' : `${(sizeW - 30)}px !important`
          }"
        @click="handleMainExpand"
      />

      <v-card-title
        @click="handleMainExpand"
      >
        <v-btn
          v-if="(title && title.length > 0) || (subtitle && subtitle.length > 0)"
          v-show="!hidden"
          :color="BGColorSecundary"
          fab
          dark
          x-small
          absolute
          top
          right
          :style="{ 'margin-top': data.BrochureImage ? '160px' : '30px' }"
          elevation="0"
          text
        >
          <!--v-icon :color="BGColorSecundary">mdi-map-search</v-icon-->
          <!--v-icon :color="ColorSecundary">{{ mainExpand ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon-->
          <v-icon large :color="BGColorSecundary">{{ mainExpand ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
        <v-layout wrap>
          <v-flex xs11>
        <div style="width:100%;line-height:1.2;margin-left:5px;" v-if="title && title.length > 0" v-html="title" class="siteTitle"
          :style="{ 'color': `${ColorContent} !important`, 'font-size': `${FontSizeContent+3}px !important` }"
        />
        <p
          v-if="subtitle && subtitle.length > 0"
          :style="{ 'color': `${ColorContent} !important`, 'font-size': `${FontSizeContent-5}px !important` }"
          style="font-weight: 400;margin: 10px 10px 10px 5px !important;opacity:0.5"
        >
          {{subtitle}}
        </p>
          </v-flex>

          <!--v-flex xs1>
            <v-icon x-large :color="BGColorSecundary">{{ mainExpand ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
          </v-flex-->
        </v-layout>
        <!--div style="width:100%;" v-if="title && title.length > 0" v-html="title" class="siteTitle"
          :style="{ 'color': `${ColorContent} !important`, 'font-size': `${FontSizeContent}px !important` }"
        />
        <span
          v-if="subtitle && subtitle.length > 0"
          class="grey--text subtitle-1"
          style="line-height: 1.2;font-weight: 400; color: rgba(0, 0, 0, 0.47);margin-bottom: 10px;"
          :style="{ 'color': `${ColorContent} !important`, 'font-size': `${FontSizeContent-5}px !important` }"
        >
          {{subtitle}}
        </span-->
      </v-card-title>
      <v-layout wrap 
        v-if="data.BrochureWithContact || data.BrochureWithLocation"
        v-show="mainExpand"
      >
        <v-card
          class="brochure-contact"
          :style="{ 'background-color': `${BGColorSecundary} !important`, 'color': `${ColorSecundary} !important` }"
          :elevation="0"
        >
        <v-toolbar
          :style="{ 'background-color': `${BGColorSecundary} !important`, 'color': `${ColorSecundary} !important` }"
          :elevation="0"
          style="border-radius: 8px;padding: 10px 0 0 0;height: auto;"
        >
            <v-icon :disabled="!phone" :style="{ color: `${ColorSecundary} !important`, opacity: !phone ? '0.2 !important' : null }" @click="handleClickPhone" >mdi-phone</v-icon>
          <v-spacer />
              <v-divider vertical :style="{ 'border-color': `${ColorSecundary} !important` }" style="opacity:0.3 !important;" />
          <v-spacer />
            <v-icon :disabled="!email" :style="{ color: `${ColorSecundary} !important`, opacity: !email ? '0.2 !important' : null }" @click="handleClickEmail" >mdi-email</v-icon>
          <v-spacer />
              <v-divider vertical :style="{ 'border-color': `${ColorSecundary} !important` }" style="opacity:0.3 !important;" />
          <v-spacer />
          <v-icon x-large @click="expandContact = !expandContact" :style="{ color: `${ColorSecundary} !important` }" >{{ expandContact ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
          <v-spacer />
              <v-divider vertical :style="{ 'border-color': `${ColorSecundary} !important` }" style="opacity:0.3 !important;" />
          <v-spacer />
            <v-icon :disabled="!web" :style="{ color: `${ColorSecundary} !important`, opacity: !web ? '0.2 !important' : null }" @click="handleClickWeb" >mdi-web</v-icon>
          <v-spacer />
              <v-divider vertical :style="{ 'border-color': `${ColorSecundary} !important` }" style="opacity:0.3 !important;" />
          <v-spacer />
            <v-icon :disabled="!showAddress" :style="{ color: `${ColorSecundary} !important`, opacity: !showAddress ? '0.2 !important' : null }" @click="handleClickMap" >mdi-map-marker</v-icon>
        </v-toolbar>
          <v-flex wrap>
          </v-flex>
          <div v-if="phone && expandContact" v-html="phone" class="brochure-contact-item-first" :style="{ 'font-size': `${FontSizeContent-5}px !important` }"/>
            <div v-if="email && expandContact" v-html="email" class="brochure-contact-item" :style="{ 'font-size': `${FontSizeContent-5}px !important`, 'border-top': `1px solid ${ColorSecundary}80 !important` }"/>
          <div v-if="web && expandContact" v-html="web" class="brochure-contact-item" :style="{ 'font-size': `${FontSizeContent-5}px !important`, 'border-top': `1px solid ${ColorSecundary}80 !important` }" />
          <div v-if="address && expandContact" v-html="address" class="brochure-contact-item" :style="{ 'font-size': `${FontSizeContent-5}px !important`, 'border-top': `1px solid ${ColorSecundary}80 !important` }"/>
        </v-card>
      </v-layout>
      <v-layout wrap 
        v-if="data.BrochureWithDescription"
        class="brochure-description"
        v-show="mainExpand"
        style="margin-top: 8px;"
      >
      <div
class="result-html"
        >
        <v-flex xs12
          class="ql-editor ql-blank"
          :style="{ 'color': `${ColorContent} !important`, 'font-size': `${FontSizeContent-4}px !important` }"
          v-html="description"
        />
      </div>
        <v-flex xs12>
        <span
          :style="{ 'color': `${ColorContent} !important`, 'font-size': `${FontSizeContent-5}px !important` }"
          style="opacity: 0.5;"
        >
          {{ note }}
        </span>
        </v-flex>
      </v-layout>
      <v-layout wrap 
        v-if="data.BrochureWithFacts && (hours || price)"
        class="brochure-facts"
        v-show="mainExpand"
      >
        <v-flex xs12>
        <v-divider v-if="hours" :style="{ 'border-color': `${ColorContent} !important` }" style="margin-bottom: 10px;opacity:0.3!important" />
        <p class="title"
          v-if="hours"
          :style="{ 'font-family': `${FontContent} !important`, 'color': `${ColorContent} !important`, 'font-size': `${FontSizeContent}px !important` }"
          v-html="$t('brochure.hours', locale)"
        />
        <p class="subtitle"
          v-if="hours"
          :style="{ 'color': `${ColorContent} !important`, 'font-size': `${FontSizeContent-5}px !important` }"
          v-html="hours"
        />
        <v-divider v-if="hours" :style="{ 'border-color': `${ColorContent} !important` }" style="margin-top:20px;margin-bottom: 10px;opacity:0.3!important"/>
        <p class="title"
          v-if="price"
          :style="{ 'font-family': `${FontContent} !important`, 'color': `${ColorContent} !important`, 'font-size': `${FontSizeContent}px !important` }"
          v-html="$t('brochure.price', locale)"
        />
        <p class="subtitle"
          v-if="price"
          :style="{ 'color': `${ColorContent} !important`, 'font-size': `${FontSizeContent-5}px !important` }"
          v-html="price"
        />
        </v-flex>
      </v-layout>
      <v-layout wrap 
        v-if="data.BrochureWithFacts && services"
        style="padding: 0px;"
        v-show="mainExpand"
      >
        <v-card
          class="brochure-services"
          :elevation="0"
        >
        <p class="title"
          :style="{ 'font-family': `${FontContent} !important`, 'color': `${ColorContent} !important`, 'font-size': `${FontSizeContent}px !important` }"
          v-html="$t('brochure.services', locale)"
        />
          <div v-if="services" v-html="services" 
            :style="{ 'color': `${ColorContent} !important`, 'font-size': `${FontSizeContent-4}px !important` }"
          />
        </v-card>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
  const minToolbar = [[],[],[],[],[],[],[],[],[],[],[],[],[{  }],[]]

  import { mapState } from 'vuex'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import { VueEditor } from "vue2-editor"
  export default {
    components: {
      VueEditor
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      show: false,
      aux: minToolbar,
      expandContact: false,
      mainExpand: false,
      hidden: false,
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'BGColorContent', 'ColorContent', 'BGColorSecundary', 'ColorSecundary']),
      isTotem () {
        return this.$route.path.indexOf('/totem') === 0 || utils.isTotem()
      },
      title () {
        return this.data.BrochureTitle ? utils.getTranslation (this.data.BrochureTitle, this.locale) : ''
      },
      subtitle () {
        return this.data.BrochureSubtitle ? utils.getTranslation (this.data.BrochureSubtitle, this.locale) : ''
      },
      description () {
        let aux = utils.getTranslation (this.data.BrochureDescription, this.locale)
        if (aux) aux = aux.replace(/\n/g, '<br />')
        return this.data.BrochureWithDescription && aux && this.data.BrochureDescription ? aux : null
      },
      note () {
        return this.data.BrochureWithDescription && this.data.BrochureNote ? utils.getTranslation (this.data.BrochureNote, this.locale) : null
      },
      hours () {
        let aux = this.data.BrochureWithFacts && this.data.BrochureHours ? utils.getTranslation (this.data.BrochureHours, this.locale) : null
        if (aux) aux = aux.replace(/\n/g, '<br />')
        return aux
      },
      price () {
        let aux = this.data.BrochureWithFacts && this.data.BrochurePrice ? utils.getTranslation (this.data.BrochurePrice, this.locale) : null
        if (aux) aux = aux.replace(/\n/g, '<br />')
        return aux
      },
      services () {
        let aux = this.data.BrochureWithFacts && this.data.BrochureServices ? utils.getTranslation (this.data.BrochureServices, this.locale) : null
        if (aux) aux = aux.replace(/\n/g, '<br />')
        return aux
      },
      phone () {
        return this.data.BrochureWithContact && this.data.BrochurePhone ? this.$t('brochure.phone', this.locale).substring(0, 3) + '.: ' + this.data.BrochurePhone : null
      },
      email () {
        return this.data.BrochureWithContact && this.data.BrochureEmail ? this.$t('brochure.email', this.locale) + ': ' + this.data.BrochureEmail : null
      },
      web () {
        return this.data.BrochureWithContact && this.data.BrochureWeb ? this.$t('brochure.web', this.locale) + ': ' + this.data.BrochureWeb : null
      },
      address () {
        let aux = this.data.BrochureAddress ? this.data.BrochureAddress + ' ' : ''
        aux = this.data.BrochurePostalCode ? aux + this.data.BrochurePostalCode + ' ' : ''
        aux = this.data.BrochureMunicipaly ? aux + this.data.BrochureMunicipaly + ' ' : ''
        return this.data.BrochureWithLocation && aux.length > 0 ? this.$t('brochure.address', this.locale) + ': ' + aux : null
      },
      showAddress () {
        return (this.address && this.address.length > 0) || (this.data.BrochureLat && this.data.BrochureLon && this.data.BrochureLat.length > 0 && this.data.BrochureLon.length > 0) ? true : false
      },

      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop() {
        return !utils.isMobile()
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      },
    },
    methods: {
      handleMainExpand () {
        this.mainExpand = !this.mainExpand
      },
      prepareTitle (v) {
        const result = `<p class="title" style="font-size:${this.FontSizeContent}px !important;">${v}</p>`
        return result
      },
      handleClickPhone () {
        if (this.isTotem) return
        const url = `tel:${this.data.BrochurePhone}`
        window.location.href = url
      },
      handleClickMap () {
        if (this.isTotem) return
        const coord = `${this.data.BrochureLat}%2C${this.data.BrochureLon}`
        const url = `https://maps.google.com/maps?q=${coord}&t=&z=13&ie=UTF8&iwloc=&output=embed`
        window.open(
          url,
          '_blank' // <- This is what makes it open in a new window.
        )
      },
      handleClickEmail () {
        if (this.isTotem) return
        const url = `mailto:${this.data.BrochureEmail}`
        window.location.href = url
      },
      handleClickWeb () {
        if (this.isTotem) return
        let url = this.data.BrochureWeb
        if(url && url.toUpperCase().indexOf('HTTP') === -1) url = 'http://'.concat(url)
        window.open(
          url,
          '_blank' // <- This is what makes it open in a new window.
        )
      },
    }
  }
</script>
<style scope>
.brochure .v-toolbar__content {
  height: 40px!important;
}
  .brochure p {
    line-height: 1.2;
    margin: 0px !important;
    width: 100%;
  }
  .brochure-description {
    padding: 10px 20px;
  }

  .brochure-facts {
    padding: 10px 20px;
  }

  .brochure-contact {
    width: 100%;
    margin: 5px 10px !important;
    border-radius: 8px !important;
    padding-bottom: 10px;
  }

  .brochure-contact-item {
    margin: 0px 20px;
    padding: 8px 0px;
  }

  .brochure-contact-item-first {
    margin: 0px 20px;
    padding: 8px 0 8px 0;
  }

  .brochure-services {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.07) !important;
    margin: 15px !important;
    padding: 5px 10px 10px 10px;
    border-radius: 8px !important;
  }
  /*.brochure-services .title {
    line-height: 1;
    margin: 0px;
  }*/
  .ql-editor p {
    font-size: var(--FontSizeContent);
  }
  .result-html .ql-toolbar.ql-snow {
    height: 0px !important;
    padding: 0px !important;
    border: 0px !important;
  }
  .result-html .ql-container.ql-snow {
    border: 0px !important;
  }
  .result-html .ql-editor {
    min-height: 0px !important;
  }   
</style>

